/*
HOW TO USE THIS:

Populate the 'announcements' array with the headers you want rotating in the website, each 'announcement' should have these fields:

background_url [mandatory]: url to an svg of 500 x 60 that will be used as background

content_html [mandatory]: html to place inside the announcement

text_color [optional]: overrides the color text to create a better contrast with the background

scope [optional]:   - "printed" this announcement should appear only on printed-related pages
                    - "non-printed" this announcement should not appear on printed-related pages
                    - <empty> this announcement should appear everywhere

expiration_date [optional]: Don't show this announcement after this date YYYY-MM-DDTHH:mm:ss.sssZ (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format)

*/

// announcements array
isPrintedGlobal = false;  //global variable to determine if the page is printed-related
const rotatingAnnouncementDebug = false;  //if set to true there will be verbosity in the console
const announcements = [
  {
    background_url: "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/autumn_high.jpg?v=1756306559",
    content_html: 'LABOR DAY FLASH SALE, 10% OFF ALL ORDERS OVER $100 Coupon Code LDPTL',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2026-09-08T00:10:00-05:00"
  },
  {
    background_url: "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/autumn_high.jpg?v=1756306559",
    content_html: 'LABOR DAY FLASH SALE, 10% OFF ALL ORDERS OVER $100 Coupon Code LDPTL',
    text_color: "white",
    scope: "printed",
    expiration_date: "2026-09-08T00:10:00-05:00"
  },
  {
    background_url: "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/poly-knit-satin-table-skirt-shirred-pleat">50% OFF Sale - All Poly Knit Table Skirts</a>',
    text_color: "white",
    scope: "non-printed",
  },
  {
    background_url:
      "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/cotton-napkins-hemstitch-mitered-corners">NEW - Cotton Hemstitched Napkins</a>',
    text_color: "white",
    scope: "non-printed",
  },
  {
    background_url:
      "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/6-custom-printed-spandex-fitted-table-cover-all-over-print">6\' Spandex All Over Print $123.76 Free Shipping</a>',
    text_color: "white",
    scope: "printed",
  },
  // {
  //   background_url:
  //     "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/1280_x_160_pixels_ba.png?v=1764082951",
  //   content_html: 'BUY NOW PAY LATER NO INTEREST AVAILABLE AT CHECKOUT',
  //   text_color: "white",
  //   scope: "non-printed"
  // },
  // {
  //   background_url:
  //     "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/1280_x_160_pixels_ba.png?v=1764082951",
  //   content_html: 'BUY NOW PAY LATER NO INTEREST AVAILABLE AT CHECKOUT',
  //   text_color: "white",
  //   scope: "printed"
  // },
  // {
  //   background_url:
  //     "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/White_Burlap_ONE-01-01_White_Gradient_3-01.jpg?v=1741971229",
  //   content_html: 'New Beautiful Product! Check our <a style="text-decoration:underline;color:black !important;" href="https://premiertablelinensrush.com/products/woven-cotton-table-runner">Cream Woven Cotton Table Runners</a> Handmade in Türkiye. ON SALE & FREE SHIPPING!!!',
  //   text_color: "black",
  //   scope: "non-printed"
  // },
  {
    background_url:
      // "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/green_christmass_gif.gif?v=1765390869",
      // "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/red_christmas_gif.gif?v=1765390866",
      // "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/WhatsApp-Video-2025-12-10-at-3.gif?v=1765404930",  //green
      // "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/WhatsApp-Video-2025-12-10-at-34.gif?v=1765404933", //red
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/WhatsApp-Video-2025-12-10-at-5.gif?v=1765406038", //red compressed
    content_html: 'Still Time To Receive Table Linens For Christmas with UPS Next Day Air. Deadline: Dec 23rd at noon (EST)',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-12-23T11:50:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/1280_x_160_pixels_ba.png?v=1764082951",
    content_html: 'Cyber Monday Sale Now Live 15% OFF sitewide all orders over $100 Coupon BF15',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-12-01T23:50:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/1280_x_160_pixels_ba.png?v=1764082951",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/collections/black-friday-2025">Click here for Black Friday Blowouts</a>',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-12-01T23:50:00-05:00"
  },/*
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/autumn_high.jpg?v=1756306559",
    content_html: 'Many of our <a style="text-decoration:underline;" href="https://premiertablelinensrush.com/search?q=oval+fall+tablecloth">Oval Fall Tablecloths</a> are On Sale!',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-12-21T23:50:00-05:00"
  },*/
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/autumn_high.jpg?v=1756306559",
    content_html: 'Labor Day Sale, 15% Off All Custom-Printed Tents With Logo. Use Code: POPUPTENT15',
    text_color: "white",
    scope: "printed",
    expiration_date: "2025-09-01T23:50:00-05:00"
  },
  {
    background_url:
      "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: 'Order now <a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/christmas-napkins">Embroidered Napkins</a> for Christmas at 10% off!',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-12-21T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/autumn_high.jpg?v=1756306559",
    content_html: 'Check out our new <a style="text-decoration:underline;" href="https://premiertablelinensrush.com/blogs/news/fall-tablecloth-thanksgiving-tablecloth-colors-tablescape">Thanksgiving tablescape inspiration</a> blog',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-11-11T23:50:00-05:00"
  },
  // {
  //   background_url:
  //     "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
  //   content_html: 'NEW PRODUCT! <a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/custom-embroidered-napkins">Napkins Embroidered With Logo</a>',
  //   text_color: "white",
  //   scope: "printed"
  // },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/4th-july-banner.gif?v=1781193438",
    content_html: '<a style="" href="https://premiertablelinensrush.com/collections/4th-of-july"><span style="color:red">NEW</span> <span style="color:white">Patriotic</span> <span style="color:lightblue">Tablecloths</span>, <span style="color:red">All</span> <span style="color:white">Sizes</span> <span style="color:lightblue">Available</span></a>',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2026-07-02T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/4th-july-banner.gif?v=1781193438",
    content_html: '<a href="https://premiertablelinensrush.com/pages/4th-july-250">25% OFF on 4th of July themed table covers and skirts</a>',
    text_color: "white",
    scope: "printed",
    expiration_date: "2026-07-02T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/image_6_Edit-03.jpg?v=1751383634",
    content_html: 'JULY 4th WEEK LONG SALE - 15% OFF ALL PURCHASES $1OO OR MORE. NO COUPON CODE REQUIRED',
    text_color: "white",
    scope: "printed",
    expiration_date: "2025-07-07T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/yellow-warning.jpg?v=1746471927",
    content_html: 'Tariffs Price Increase Take Effect on Monday May 12. Take Advantage Of Current Prices This Week!',
    text_color: "black",
    scope: "non-printed",
    expiration_date: "2025-05-12T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/valentine-mobile_Red.svg?v=1737557806",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/products/valentines-day-table-runner">We have St. Valentine\'s Day Table Runners</a>',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-02-10T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/St_Patrick-mobile_Green_1.svg?v=1737557176",
    content_html: '<a style="text-decoration:underline;" href="https://premiertablelinensrush.com/collections/st-patricks-day-print">Check out our St. Patrick\'s Day tablecloths and table runners</a>',
    text_color: "white",
    scope: "non-printed",
    expiration_date: "2025-03-13T00:00:00-05:00"
  },
  {
    background_url:
      "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: 'Check out our <a style="text-decoration:underline;" href="https://premiertablelinensrush.com/collections/new-in-2025">New Printed Products in 2025</a>',
    text_color: "white",
    scope: "printed",
    expiration_date: "2025-12-31T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/magnolia-trees-banner.jpg?v=1743603883",
    content_html: '<a style="text-decoration:underline;color:black !important;" href=""></a>',
    text_color: "black",
    scope: "printed",
    expiration_date: "2026-06-01T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/magnolia-trees-banner.jpg?v=1743603883",
    content_html: '<a style="text-decoration:underline;color:black !important;" href="https://premiertablelinensrush.com/collections/new-in-2026">New Fabics On Sale! 12 new fabric lines available</a>',
    text_color: "black",
    scope: "non-printed",
    expiration_date: "2026-06-01T00:00:00-05:00"
  },
  {
    background_url:
      "https://appsolve.io/asset/apps/vitals/img/smart_bar/winter.svg",
    content_html: 'NEW LINEN FABRIC! Check out our <a style="text-decoration:underline;color:white !important;" href="https://premiertablelinensrush.com/collections/custom-printed-wrinkle-free-special-table-covers">Wrinkle Free Supreme Tablecloth Collection</a>',
    text_color: "white",
    scope: "printed",
    expiration_date: "2025-12-31T00:00:00-05:00"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/free-shipping-banner.svg?v=1738092836",
    content_html: 'Free, Insured UPS Ground Shipping on all Custom Prints',
    text_color: "black",
    scope: "printed"
  },
  {
    background_url:
      "https://cdn.shopify.com/s/files/1/0434/4178/2939/files/White_Burlap_ONE-01-01_White_Gradient_3-01.jpg?v=1741971229",
    content_html: 'We Now Offer <a style="text-decoration:underline;color:black !important;" href="https://premiertablelinensrush.com/products/custom-printed-burlap-table-runner-single-color-print">Full Color Printed Burlap Table Runners</a> & <a style="text-decoration:underline;color:black !important;" href="https://premiertablelinensrush.com/products/custom-printed-burlap-overlay-single-color-print">Printed Burlap Table Covers</a>',
    text_color: "black",
    scope: "printed"
  }
];

// HELPER FUNCTIONS
//////////////////////////////
// Debug function
function traceRotatingAnnouncement(msg) {
  if (rotatingAnnouncementDebug) {
    console.log('RotatingAnnouncement: ' + msg);
  } 
}

// Determines if a heading is related to the print department
function isPrinted(heading) {
  // list of known printed keywords
  const printedKeywords = [
    ' printed ',
    'printed ',
    ' printed',
    ' logo ',
    'logo ',
    ' logo',
    ' banner ',
    'banner ',
    ' banner'
  ];

  // check if the product title contains one of the keywords
  for (let i = 0; i < printedKeywords.length; i++) {
    const isolatedKeyword = printedKeywords[i];
    if (heading.toLowerCase().includes(isolatedKeyword)) {
      // if it does, return true
      isPrintedGlobal = true; //set global variable true
      return true;
    }
  }
  
  // if none of the keywords are found, return false
  return false;
}

// Determines if the current page is a product page
function isProductPage() {
  return window.location.href.includes('/products/');
}

// Determines if the current page is a collection page
function isCollectionPage() {
  return window.location.href.includes('/collections/');
}

// Determines if an announcement is valid to be shown
function isAnnouncementValid(announcement, scope) {

  // check if the annoucement has expired
  let now = new Date(); // current date
  
  if ( Object.hasOwn(announcement, 'expiration_date') ) {
    let expirationDate = new Date(announcement['expiration_date']);
    if (expirationDate < now) {
      traceRotatingAnnouncement('Announcement expired');
      traceRotatingAnnouncement('Expiration date:' + expirationDate.toString() );
      traceRotatingAnnouncement('Current date: ' + now.toString() );
      return false;
    }
    traceRotatingAnnouncement('The announcement has not expired, OK (' + expirationDate.toString() + ')');
  }
  
  // check if the annoucement is not for this scope
  if ( Object.hasOwn(announcement, 'scope') ) {
    if ( announcement['scope'] !== scope ) {
      traceRotatingAnnouncement('Announcement not suitable for this scope');
      return false;  
    }
    traceRotatingAnnouncement('The announcement scope matches, OK (' + announcement['scope'] + ')');
  }
  
  return true;
}

// ENTRY POINT
//////////////////////////////
function mainSuperSearch() {
  traceRotatingAnnouncement('Main() entry');

  var showAnnouncement = announcements.length > 0;
  
  // only work if there is something to show
  if ( showAnnouncement ) {

    // This variable will tell us if we are in a printed-related page
    let printedScope = false;
  
    // Check if we are in a printed page
    if ( isProductPage() || isCollectionPage() ) {
      traceRotatingAnnouncement('We are in a product or collection page');
  
      // Get the page main heading
      let pageHeading = document.querySelector('h1').textContent;
      traceRotatingAnnouncement('pageHeading is "' + pageHeading + '"');
  
      // Check if it is a printed-related page
      printedScope = isPrinted(pageHeading);
    }
  
    if (printedScope) {
      traceRotatingAnnouncement('This is a printed-related page');
    } else {
      traceRotatingAnnouncement('This is not a printed-related page');
    }
  
    // Get the last announcement index from localStorage or start at 0
    let currentAnnouncement = localStorage.currentAnnouncement !== undefined ? parseInt(localStorage.currentAnnouncement) : 0;
    if (currentAnnouncement > announcements.length - 1) {
      currentAnnouncement = 0;
    }
    traceRotatingAnnouncement('Announcement to show is ' + currentAnnouncement);
    
    // If the annoucement can't be shown in this scope, skip
    let scope = printedScope ? 'printed' : 'non-printed';
    traceRotatingAnnouncement('This page scope is "' + scope + '"');
    let entryIndex = currentAnnouncement;
    while ( !isAnnouncementValid(announcements[currentAnnouncement], scope) ) {
      currentAnnouncement = (currentAnnouncement + 1) % announcements.length;
      traceRotatingAnnouncement('Announcement to show is ' + currentAnnouncement);
      if (currentAnnouncement === entryIndex ) {
        traceRotatingAnnouncement('No announcement for this scope');
        showAnnouncement = false;
        break;
      }
    }

    if (showAnnouncement) {
      traceRotatingAnnouncement('Showing announcement ' + currentAnnouncement);
      
      // Display the current value
      document.getElementById('announcement-container').style.backgroundImage  = 'url(' + announcements[currentAnnouncement].background_url + ')';
      document.getElementById('announcement-container').style.minHeight  = '50px';
      document.getElementById('announcement-message').innerHTML  = announcements[currentAnnouncement].content_html;
      document.getElementById('announcement-message').style.color = announcements[currentAnnouncement].text_color;
      
      // Save the next index in localStorage
      localStorage.currentAnnouncement = (++currentAnnouncement % announcements.length).toString();
    }

  } else {
    traceRotatingAnnouncement('There are no annoucements set up');
  }

  traceRotatingAnnouncement(' The End');
}

// PAGE LOAD LISTENER
//////////////////////////////
traceRotatingAnnouncement('Setting listener for when page loads');
window.addEventListener("load", mainSuperSearch);